import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Single global scroll handler for React Router:
 * - Scrolls to top on every pathname change (no hash)
 * - Scrolls to hash targets when present
 */
function RouteScrollManager() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      let cancelled = false;
      let attempts = 0;
      const maxAttempts = 60;

      const scrollToHash = () => {
        if (cancelled) return;

        const target = document.getElementById(id);
        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }

        if (attempts++ < maxAttempts) {
          requestAnimationFrame(scrollToHash);
        }
      };

      requestAnimationFrame(scrollToHash);

      return () => {
        cancelled = true;
      };
    }

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname, location.hash]);

  return null;
}

export default RouteScrollManager;
